export function safeParse(str: string, def: any = {}): any {
  try {
    return JSON.parse(str) || def;
  } catch (e) {
    return def;
  }
}

export function formatIban(iban: string): string {
  return (iban || '').replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
}
